import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteSupportFolder = {
  name: "deleteSupportFolder" as const,
  input: z.object({ folderId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
